import { paymentTypes } from "../../utils/constants/forms-constans";

export const SportNameBodyTemplate = (rowData: any) => {
  const paymentType = paymentTypes.find(
    (item) => item.value === rowData.paymentType
  );

  return (
    <div className="flex flex-column gap-1">
      <span className="font-medium text-900">{rowData.sportName}</span>
      {paymentType && (
        <span className="text-sm text-color-secondary inline-block">
          <i className="pi pi-clock mr-1 text-xs"></i>
          {paymentType.label}
        </span>
      )}
    </div>
  );
};
